import { formatChainId, toHex } from './ethereum';
export function getSingleNetworkConfig(networkConfigs, chainId) {
    if ('chainId' in networkConfigs && networkConfigs.chainId) {
        const networkConfig = networkConfigs;
        if (chainId === networkConfig.chainId || chainId == formatChainId(networkConfig.chainId)) {
            return networkConfig;
        }
        else {
            return undefined;
        }
    }
    else {
        const multinetworkConfigs = networkConfigs;
        const networkConfig = multinetworkConfigs.chains[chainId] || multinetworkConfigs.chains[toHex(chainId)];
        if (!networkConfig) {
            return undefined;
        }
        else {
            return networkConfig;
        }
    }
}
